import React from "react";
import { API_BASE, fetchJson } from "../utils";

export default function useSetTrackMembership(setId) {
  const [state, setState] = React.useState({
    ids: new Set(),
    loading: true,
    error: null,
  });
  const [revision, setRevision] = React.useState(0);
  React.useEffect(() => {
    const controller = new AbortController();
    setState({ ids: new Set(), loading: true, error: null });
    fetchJson(`${API_BASE}/user-sets/${setId}/tracks/`, {
      signal: controller.signal,
    })
      .then((data) => {
        const tracks = Array.isArray(data) ? data : data?.tracks;
        if (!Array.isArray(tracks))
          throw new Error("Invalid set tracks response");
        const ids = new Set(
          tracks.map((entry) =>
            String(entry.track?.id ?? entry.track ?? entry.id),
          ),
        );
        if (!controller.signal.aborted)
          setState({ ids, loading: false, error: null });
      })
      .catch((error) => {
        if (!controller.signal.aborted)
          setState({ ids: new Set(), loading: false, error });
      });
    return () => controller.abort();
  }, [setId, revision]);
  return { ...state, retry: () => setRevision((value) => value + 1) };
}
